import React, { useMemo, useState } from 'react'
import Pagination from '../Pagination';
import { useTranslation } from 'react-i18next';

interface TableProps<T = React.ReactNode> {
    headers: string[];
    data?: (T[])[];
    itemsPerPage?: number;
    hidePagination?: boolean;
    pagesCount?: number;
    onClickItem?: (itemIndex: number) => any;
}

const Table: React.FC<TableProps> = ({ headers, data = [], itemsPerPage = 5, onClickItem
    // hidePagination, pagesCount = 0
}) => {

    // const [page, setPage] = useState(0);
    // const items = useMemo(() => data.slice((page * itemsPerPage), (page * itemsPerPage) + itemsPerPage), [page, data])

    // const setPageChanged = async (pageNum: number) => {
    //     if (onChangePage) {
    //         await onChangePage(pageNum);
    //     }
    //     setPage(pageNum);
    // }

    const { i18n: { dir } } = useTranslation()

    return (
        <>
            <table className='font-Poppins w-full font-medium text-base '>
                <thead className=' text-[#6F767E]'>
                    <tr className='first:rounded-l-xl bg-[#F5F5F5] last:rounded-r-xl'>

                        {headers.map((header) => (
                            <th key={header} className={`p-3 ${dir() === 'ltr' ? "first:rounded-l-xl last:rounded-r-xl" : "first:rounded-r-xl last:rounded-l-xl"} text-start`} >
                                {header}
                            </th>

                        ))}
                    </tr>
                </thead>
                <tbody className=''>
                    {data.map((row, rowIndex) => (
                        <tr onClick={() => onClickItem && onClickItem(rowIndex)} key={rowIndex} className='hover:bg-light-secondary/10 rounded-lg cursor-pointer '>
                            {row.map((cell, cellIndex) => (
                                <td key={cellIndex} className={`p-3 ${dir() === 'ltr' ? "first:rounded-l-xl last:rounded-r-xl" : "first:rounded-r-xl last:rounded-l-xl"} text-start`}>
                                    {cell}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className='h-[1px] w-full rounded-[1px] bg-[#EDF1F3] my-5' />

            {/* {!hidePagination && pagesCount > 0 && <Pagination pagesCount={pagesCount} itemsPerPage={5} onPageChanged={setPageChanged} />} */}
        </>
    )

}

export default Table;